export default "__VITE_PUBLIC_ASSET__9a77d4e4__"